module.exports = __webpack_public_path__ + "static/Diplomat-Group-531e535e561a61cb514f9d8b1b960c72.png";